// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 10/10/2023
 */


.introVid_topic__zj7PE {
    font-size: 3rem;
    font-style: normal;
    font-weight: 300;
    text-align: center;
    
    margin-bottom: 50px;
}

.introVid_imgContainer__WDd-3 {
    display: flex;
    justify-content: center;
    margin-top: 1.5rem;
}

.introVid_video__WZuu2 {
    height: 30rem;
    width: 50rem;
}

@media (max-width: 770px) {
    .introVid_img__xl\\+gn {
        width: 14rem;
        height: 8rem;
    }

    .introVid_video__WZuu2 {
        width: 14rem;
        height: 8rem;
    }
    .introVid_topic__zj7PE {
        font-size: 3rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/aboutUs/introVid.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;;AAGF;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;;IAElB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 10/10/2023\r\n */\r\n\r\n\r\n.topic {\r\n    font-size: 3rem;\r\n    font-style: normal;\r\n    font-weight: 300;\r\n    text-align: center;\r\n    \r\n    margin-bottom: 50px;\r\n}\r\n\r\n.imgContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 1.5rem;\r\n}\r\n\r\n.video {\r\n    height: 30rem;\r\n    width: 50rem;\r\n}\r\n\r\n@media (max-width: 770px) {\r\n    .img {\r\n        width: 14rem;\r\n        height: 8rem;\r\n    }\r\n\r\n    .video {\r\n        width: 14rem;\r\n        height: 8rem;\r\n    }\r\n    .topic {\r\n        font-size: 3rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topic": `introVid_topic__zj7PE`,
	"imgContainer": `introVid_imgContainer__WDd-3`,
	"video": `introVid_video__WZuu2`,
	"img": `introVid_img__xl+gn`
};
export default ___CSS_LOADER_EXPORT___;
